module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.loading && _vm.appointmentCount === 0) ? _c('v-card', {
    attrs: {
      "tile": "",
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    staticClass: "ma-4 pa-4",
    attrs: {
      "color": "amber",
      "size": "42",
      "width": "2",
      "indeterminate": ""
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s(_vm.$t('loading')))])], 1)], 1) : [(_vm.appointmentCount > 0) ? _c('v-card', {
    attrs: {
      "flat": _vm.$vuetify.breakpoint.xs
    }
  }, [_c('v-card-title', [_c('v-menu', [_c('span', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("expand_more")]), _vm._v(" "), (_vm.mainchartId === "value") ? _c('span', [_vm._v("\n                  " + _vm._s(_vm.$t('mainchart.titles.value')) + "\n                ")]) : _c('span', [_vm._v("\n                  " + _vm._s(_vm.$t('mainchart.titles.count')) + "\n                ")])], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.mainchartId = "value"
      }
    }
  }, [_c('v-list-tile-title', [_vm._v("\n                    " + _vm._s(_vm.$t('mainchart.titles.value')) + "\n                  ")])], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.mainchartId = "count"
      }
    }
  }, [_c('v-list-tile-title', [_vm._v("\n                    " + _vm._s(_vm.$t('mainchart.titles.count')) + "\n                  ")])], 1)], 1)], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.chartType = "bar"
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("bar_chart")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.chartType = "area"
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("show_chart")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('h3', {
    staticClass: "subheader"
  }, [_vm._v(_vm._s(_vm.dateRangeFormatted))])], 1), _vm._v(" "), _c('apex-chart', {
    attrs: {
      "height": "200px",
      "width": "100%",
      "type": _vm.chartType,
      "options": _vm.options,
      "series": _vm.series
    }
  })], 1) : _c('v-card', [_c('v-layout', {
    staticStyle: {
      "background-image": "url(\"/static/img/placeholders/analyza_data_and_chart.png\")",
      "background-repeat": "no-repeat",
      "background-attachment": "fixed",
      "background-position": "right top"
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs6": ""
    }
  }, [_c('h3', {
    staticClass: "headline mt-4 pa-4"
  }, [_vm._v("Looks like you don't have any recent appointments")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    staticClass: "ma-4",
    attrs: {
      "large": "",
      "color": "success"
    },
    on: {
      "click": function($event) {
        return _vm.openGlobalDialog(true, 'QuickCreate')
      }
    }
  }, [_vm._v("Create an appointment")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-4",
    attrs: {
      "to": "/settings/get-online",
      "large": "",
      "color": "primary"
    }
  }, [_vm._v("Get online bookings")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right mr-4"
  })], 1)], 1)]], 2)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2",
    attrs: {
      "row": "",
      "wrap": "",
      "fill-height": ""
    }
  }, [_c('v-flex', {
    staticClass: "white pa-0",
    attrs: {
      "column": "",
      "xs12": "",
      "sm12": "",
      "md6": "",
      "md12": _vm.appointmentCount === 0
    }
  }, [_c('v-card', {
    staticStyle: {
      "min-height": "238"
    },
    attrs: {
      "tile": "",
      "dark": "",
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pt-0"
  }, [_c('v-flex', {
    staticClass: "mt-3"
  }, [_c('div', {
    staticClass: "title font-weight-light mb-2"
  }, [_vm._v(_vm._s(_vm.$t('metrics.titles.count')))]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-light grey--text"
  }, [_vm._v(_vm._s(_vm.dateRangeFormatted))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right headline pt-2"
  }, [_vm._v("\n          " + _vm._s(_vm.appointmentCount) + "\n          ")])], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pt-0"
  }, [_c('v-flex', {
    staticClass: "mt-3"
  }, [_c('div', {
    staticClass: "title font-weight-light mb-2"
  }, [_vm._v(_vm._s(_vm.$t('metrics.titles.value')))]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-light grey--text"
  }, [_vm._v(_vm._s(_vm.$t('metrics.subtitles.value')))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right headline pt-2",
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("\n          " + _vm._s(_vm.formatCurrency(_vm.settings.currency, _vm.appointmentValue)) + "\n          ")])], 1)], 1)], 1), _vm._v(" "), (_vm.appointmentCount > 0) ? _c('v-flex', {
    staticClass: "white pa-0",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md6": "",
      "column": ""
    }
  }, [_c('v-card', {
    attrs: {
      "tile": "",
      "flat": ""
    }
  }, [_c('apex-chart', {
    attrs: {
      "height": "250",
      "type": "radialBar",
      "options": _vm.statusBreakdown.chartOptions,
      "series": _vm.statusBreakdown.series
    }
  })], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-415aa39e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/Welcome.vue
// module id = 1402
// module chunks = 9